import { Modal, Button } from "@oysterhr/ui"
import { useCallback } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

export type ConfirmExitModalProps = {
  setShowModal(val: boolean): void
  link: string
}

export const ConfirmExitModal = ({ setShowModal, link }: ConfirmExitModalProps) => {
  const { t } = useTranslation("company_interface/CompanyPaymentMethodsPage")
  const navigate = useNavigate()
  const onExit = useCallback(() => {
    setShowModal(false)
    navigate(link)
  }, [link, setShowModal, navigate])

  return (
    <Modal isOpen onRequestClose={() => setShowModal(false)}>
      <Modal.Header>{t("exitModal.title")}</Modal.Header>
      <Modal.Content>{t("exitModal.message")}</Modal.Content>
      <Modal.Footer>
        <Button onClick={onExit} variation="outline">
          {t("exitModal.quit")}
        </Button>

        <Button onClick={() => setShowModal(false)}>{t("exitModal.continue")}</Button>
      </Modal.Footer>
    </Modal>
  )
}
